import { useState } from "react";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/Common";

export const ForgotPasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (x) {
      toast.error(errMsg(x));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) { setSent(false); setEmail(""); } }}>
      <DialogTrigger asChild>
        <button type="button" data-testid="forgot-password-link" className="text-xs font-semibold text-sky-700 hover:underline">Password dimenticata?</button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reimposta la password</DialogTitle>
          <DialogDescription>Inserisci la tua email: ti invieremo un link per sceglierne una nuova.</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div data-testid="forgot-password-sent" className="flex gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
            <MailCheck className="h-5 w-5 shrink-0" />
            Se l'indirizzo è registrato riceverai a breve un'email con il link. Il link vale 1 ora.
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Field label="Email">
              <Input data-testid="forgot-password-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </Field>
            <DialogFooter>
              <Button data-testid="forgot-password-submit" disabled={busy} className="bg-sky-600 hover:bg-sky-700">{busy ? "Invio…" : "Invia link"}</Button>
            </DialogFooter>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
